import React from "react";
import { Dataset } from "./types";
import "./style.css";
import { Button } from "primereact/button";
import Remove from "./icons/Remove";

const SelectedDatasetElement = (props: any) => {
  const selectedDataset = props.children[0];
  const removeDataset = props.children[1];
  
  const onRemove = (removedId: string) => {
    removeDataset(removedId);
  };
  //data-tooltip={selectedDataset.formatedString}
  return (
    <div key={selectedDataset.identifier} id={selectedDataset.identifier} className={`text selectedDataset`} {...props}>
      <span className="text">{selectedDataset.formatedTitle}</span>
      <div className="removeIcon" onClick={() => onRemove(selectedDataset.identifier)}><Remove  width={7} height={7}/></div>
    </div>
  );
};

export default SelectedDatasetElement;
